(function () {
  function shuffle(list) {
    var copy = list.slice();
    for (var i = copy.length - 1; i > 0; i -= 1) {
      var j = Math.floor(Math.random() * (i + 1));
      var swap = copy[i];
      copy[i] = copy[j];
      copy[j] = swap;
    }
    return copy;
  }

  function frames(tile) {
    return Array.prototype.slice.call(tile.querySelectorAll('.welcome-products__frame'));
  }

  function activeFrame(tile) {
    return tile.querySelector('.welcome-products__frame.is-active') || frames(tile)[0];
  }

  function ripple(tile, hold, timers) {
    var list = frames(tile);
    if (list.length < 2 || tile.classList.contains('is-rippling')) return;
    var current = list.indexOf(activeFrame(tile));
    if (current < 0) current = 0;
    var next = list[(current + 1) % list.length];
    var ms = hold || 560;
    var nextImage = next.querySelector('img');
    if (nextImage && !nextImage.complete) {
      nextImage.addEventListener('load', function () {
        ripple(tile, hold, timers);
      }, { once: true });
      return;
    }
    next.style.setProperty('--welcome-reveal', ms + 'ms');
    next.classList.add('is-incoming');
    tile.classList.add('is-rippling');
    timers.push(window.setTimeout(function () {
      list.forEach(function (frame) {
        frame.classList.remove('is-active', 'is-incoming');
      });
      next.classList.add('is-active');
      tile.classList.remove('is-rippling');
      var label = next.getAttribute('data-label');
      if (label) tile.setAttribute('aria-label', label);
    }, ms));
  }

  function init(root) {
    if (!root || root.getAttribute('data-welcome-init') === '1') return;
    root.setAttribute('data-welcome-init', '1');

    var grid = root.querySelector('[data-welcome-grid]');
    var dialog = root.querySelector('[data-welcome-dialog]');
    var scroller = root.querySelector('[data-welcome-scroller]');
    if (!grid || !dialog || !scroller) return;

    var tiles = Array.prototype.slice.call(grid.querySelectorAll('[data-block-id]'));
    var designMode = window.Shopify && window.Shopify.designMode;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var effectOn = root.getAttribute('data-effect') !== '0';
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 4000;
    var timers = [];

    if (!designMode && tiles.length > 1) {
      shuffle(tiles).forEach(function (tile) {
        grid.appendChild(tile);
      });
      tiles = Array.prototype.slice.call(grid.querySelectorAll('[data-block-id]'));
    }

    if (!designMode) {
      tiles.forEach(function (tile) {
        var list = frames(tile);
        if (list.length < 2) return;
        var start = Math.floor(Math.random() * list.length);
        list.forEach(function (frame, index) {
          frame.classList.toggle('is-active', index === start);
        });
        var label = list[start].getAttribute('data-label');
        if (label) tile.setAttribute('aria-label', label);
      });
    }

    grid.classList.add('is-ready');

    function clearWaveTimers() {
      timers.forEach(function (timer) { window.clearTimeout(timer); });
      timers = [];
      root._welcomeTimers = timers;
    }

    function settleTiles() {
      tiles.forEach(function (tile) {
        var incoming = tile.querySelector('.welcome-products__frame.is-incoming');
        if (incoming) {
          frames(tile).forEach(function (frame) {
            frame.classList.remove('is-active', 'is-incoming');
          });
          incoming.classList.add('is-active');
          var label = incoming.getAttribute('data-label');
          if (label) tile.setAttribute('aria-label', label);
        }
        tile.classList.remove('is-rippling');
      });
    }

    function queueNext(delay) {
      window.clearTimeout(root._welcomeNext);
      root._welcomeNext = window.setTimeout(wave, delay);
    }

    function stopWave() {
      clearWaveTimers();
      grid.classList.remove('is-waving');
      tiles.forEach(function (tile) {
        tile.classList.remove('is-rippling');
        frames(tile).forEach(function (frame) {
          frame.classList.remove('is-incoming');
        });
      });
    }

    function wave() {
      if (!effectOn) return;
      if (dialog.open || root.getAttribute('data-welcome-paused') === '1') {
        queueNext(700);
        return;
      }
      settleTiles();
      clearWaveTimers();

      var gridRect = grid.getBoundingClientRect();
      var span = gridRect.width + gridRect.height;
      if (span < 1) {
        queueNext(300);
        return;
      }
      var duration = Math.max(2200, Math.round(span * 3.2));
      grid.style.setProperty('--welcome-wave-duration', duration + 'ms');

      var ordered = tiles.slice().sort(function (a, b) {
        var ar = a.getBoundingClientRect();
        var br = b.getBoundingClientRect();
        return (ar.top + ar.left) - (br.top + br.left);
      });

      if (!reduceMotion) {
        grid.classList.remove('is-waving');
        void grid.offsetWidth;
        grid.classList.add('is-waving');
        timers.push(window.setTimeout(function () {
          grid.classList.remove('is-waving');
        }, duration + 40));
      }

      ordered.forEach(function (tile) {
        var rect = tile.getBoundingClientRect();
        var start = ((rect.left - gridRect.left) + (rect.top - gridRect.top)) / span;
        var cross = Math.max(280, ((rect.width + rect.height) / span) * duration);
        var delay = reduceMotion ? 0 : Math.max(0, Math.round(start * duration));
        timers.push(window.setTimeout(function () {
          if (reduceMotion) {
            var list = frames(tile);
            if (list.length < 2) return;
            var current = list.indexOf(activeFrame(tile));
            var next = list[(current + 1) % list.length];
            list.forEach(function (frame) { frame.classList.remove('is-active'); });
            next.classList.add('is-active');
            var label = next.getAttribute('data-label');
            if (label) tile.setAttribute('aria-label', label);
            return;
          }
          if (dialog.open) return;
          ripple(tile, Math.round(cross), timers);
        }, delay));
      });
      root._welcomeTimers = timers;
      queueNext(duration + Math.max(interval, 1200));
    }

    function whenTilesReady(done) {
      var imgs = grid.querySelectorAll('.welcome-products__frame img');
      var pending = imgs.length;
      var finished = false;
      function finish() {
        if (finished) return;
        finished = true;
        done();
      }
      if (!pending) {
        finish();
        return;
      }
      window.setTimeout(finish, 4000);
      Array.prototype.forEach.call(imgs, function (img) {
        function mark() {
          pending -= 1;
          if (pending <= 0) finish();
        }
        function ready() {
          if (img.decode) {
            img.decode().then(mark, mark);
          } else {
            mark();
          }
        }
        if (img.complete) ready();
        else {
          img.addEventListener('load', ready, { once: true });
          img.addEventListener('error', mark, { once: true });
        }
      });
    }

    if (effectOn && tiles.length) {
      whenTilesReady(function () { queueNext(80); });
    }

    if (window.matchMedia('(hover: hover)').matches) {
      grid.addEventListener('mouseenter', function () {
        root.setAttribute('data-welcome-paused', '1');
      });
      grid.addEventListener('mouseleave', function () {
        root.removeAttribute('data-welcome-paused');
      });
    }

    function visibleCards() {
      return Array.prototype.slice.call(scroller.querySelectorAll('[data-welcome-card]:not([hidden])'));
    }

    function cloneCard(card, placement) {
      var copy = card.cloneNode(true);
      copy.setAttribute('data-welcome-clone', placement);
      copy.removeAttribute('hidden');
      copy.querySelectorAll('[id]').forEach(function (node) {
        node.removeAttribute('id');
      });
      return copy;
    }

    function buildLoop(blockId) {
      scroller.querySelectorAll('[data-welcome-clone]').forEach(function (node) {
        node.remove();
      });
      var cards = Array.prototype.slice.call(scroller.querySelectorAll('[data-welcome-card]'));
      var visible = [];
      cards.forEach(function (card) {
        var show = card.getAttribute('data-block-id') === blockId;
        card.hidden = !show;
        if (show) visible.push(card);
      });
      var prevNav = root.querySelector('[data-welcome-prev]');
      var nextNav = root.querySelector('[data-welcome-next]');
      if (prevNav) prevNav.hidden = visible.length < 2;
      if (nextNav) nextNav.hidden = visible.length < 2;
      if (visible.length < 2) return;
      var before = document.createDocumentFragment();
      var after = document.createDocumentFragment();
      visible.forEach(function (card) {
        before.appendChild(cloneCard(card, 'before'));
        after.appendChild(cloneCard(card, 'after'));
      });
      visible[0].parentNode.insertBefore(before, visible[0]);
      visible[visible.length - 1].parentNode.insertBefore(after, visible[visible.length - 1].nextSibling);
    }

    function realCard(card) {
      if (!card || !card.hasAttribute('data-welcome-clone')) return card;
      var kind = card.getAttribute('data-welcome-clone');
      var copies = visibleCards().filter(function (item) {
        return item.getAttribute('data-welcome-clone') === kind;
      });
      var reals = visibleCards().filter(function (item) {
        return !item.hasAttribute('data-welcome-clone');
      });
      return reals[copies.indexOf(card)] || card;
    }

    function normalizeLoop() {
      if (!dialog.open) return;
      var current = centeredCard();
      var real = realCard(current);
      if (!current || !real || real === current) return;
      var delta = real.getBoundingClientRect().left - current.getBoundingClientRect().left;
      if (Math.abs(delta) < 2) return;
      scroller.style.scrollSnapType = 'none';
      scroller.scrollLeft += delta;
      scroller.style.scrollSnapType = '';
      showCopy(real.getAttribute('data-block-id'), real.getAttribute('data-slot'));
    }

    function showCopy(blockId, slot) {
      var copies = root.querySelectorAll('[data-welcome-copy]');
      if (!copies.length) return;
      Array.prototype.forEach.call(copies, function (node) {
        var sameBlock = node.getAttribute('data-block-id') === blockId;
        var nodeSlot = node.getAttribute('data-slot');
        var sameSlot = !nodeSlot || !slot || nodeSlot === String(slot);
        node.hidden = !(sameBlock && sameSlot);
      });
      var title = null;
      if (slot) title = root.querySelector('[data-welcome-title][data-block-id="' + blockId + '"][data-slot="' + slot + '"]');
      if (!title) title = root.querySelector('[data-welcome-title][data-block-id="' + blockId + '"]');
      if (title && title.id) dialog.setAttribute('aria-labelledby', title.id);
    }

    function syncCentered() {
      var current = centeredCard();
      var real = realCard(current);
      if (!real) return;
      showCopy(real.getAttribute('data-block-id'), real.getAttribute('data-slot'));
    }

    function syncViewLink(blockId) {
      var view = root.querySelector('[data-welcome-view]');
      if (!view) return;
      var tile = grid.querySelector('[data-block-id="' + blockId + '"]');
      var url = tile ? tile.getAttribute('data-product-url') : '';
      if (url) {
        view.setAttribute('href', url);
        view.hidden = false;
      } else {
        view.hidden = true;
        view.removeAttribute('href');
      }
    }

    function openDialog(blockId, productId, slot) {
      if (typeof dialog.showModal !== 'function') return;
      stopWave();
      buildLoop(blockId);
      showCopy(blockId, slot);
      syncViewLink(blockId);
      dialog.showModal();
      window.requestAnimationFrame(function () {
        dialog.classList.add('is-shown');
        var card = null;
        if (slot) {
          card = scroller.querySelector('[data-block-id="' + blockId + '"][data-slot="' + slot + '"]:not([data-welcome-clone])');
        }
        if (!card || card.hidden) {
          card = scroller.querySelector('[data-block-id="' + blockId + '"][data-product-id="' + productId + '"]:not([data-welcome-clone])');
        }
        if (!card || card.hidden) {
          card = scroller.querySelector('[data-block-id="' + blockId + '"]:not([hidden]):not([data-welcome-clone])');
        }
        if (card) {
          card.scrollIntoView({ inline: 'center', block: 'nearest' });
          showCopy(card.getAttribute('data-block-id'), card.getAttribute('data-slot'));
        }
      });
    }

    function closeDialog() {
      dialog.classList.remove('is-shown');
      window.setTimeout(function () {
        if (dialog.open) dialog.close();
      }, 460);
    }

    grid.addEventListener('click', function (event) {
      var tile = event.target.closest('[data-block-id]');
      if (!tile || !grid.contains(tile)) return;
      var frame = activeFrame(tile);
      openDialog(
        tile.getAttribute('data-block-id'),
        frame ? frame.getAttribute('data-product-id') : '',
        frame ? frame.getAttribute('data-slot') : ''
      );
    });

    root.querySelectorAll('[data-welcome-close]').forEach(function (closeButton) {
      closeButton.addEventListener('click', closeDialog);
    });

    dialog.addEventListener('cancel', function (event) {
      event.preventDefault();
      closeDialog();
    });

    dialog.addEventListener('click', function (event) {
      var more = event.target.closest('[data-welcome-more]');
      if (more && dialog.contains(more)) {
        var card = more.closest('[data-welcome-card]');
        var desc = more.closest('[data-welcome-desc]');
        if (!desc) return;
        var expanded = !desc.classList.contains('is-expanded');
        if (!card) {
          desc.classList.toggle('is-expanded', expanded);
          more.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          more.textContent = expanded ? more.getAttribute('data-label-less') : more.getAttribute('data-label-more');
          return;
        }
        var blockId = card.getAttribute('data-block-id');
        var slot = card.getAttribute('data-slot');
        scroller.querySelectorAll('[data-welcome-card][data-block-id="' + blockId + '"][data-slot="' + slot + '"]').forEach(function (match) {
          var matchDesc = match.querySelector('[data-welcome-desc]');
          var matchMore = match.querySelector('[data-welcome-more]');
          if (!matchDesc || !matchMore) return;
          matchDesc.classList.toggle('is-expanded', expanded);
          matchMore.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          matchMore.textContent = expanded ? matchMore.getAttribute('data-label-less') : matchMore.getAttribute('data-label-more');
        });
        return;
      }
      if (event.target === dialog) closeDialog();
    });

    function centeredCard() {
      var cards = visibleCards();
      var mid = scroller.getBoundingClientRect().left + scroller.clientWidth / 2;
      var best = null;
      var bestDistance = Infinity;
      cards.forEach(function (card) {
        var rect = card.getBoundingClientRect();
        var distance = Math.abs(rect.left + rect.width / 2 - mid);
        if (distance < bestDistance) {
          best = card;
          bestDistance = distance;
        }
      });
      return best;
    }

    function scrollByCard(direction) {
      normalizeLoop();
      var cards = visibleCards();
      var current = centeredCard();
      var index = cards.indexOf(current);
      var target = cards[index + direction];
      if (!target && cards.length) {
        target = direction > 0 ? cards[0] : cards[cards.length - 1];
      }
      if (!target) return;
      target.scrollIntoView({ inline: 'center', block: 'nearest', behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    var prev = root.querySelector('[data-welcome-prev]');
    var next = root.querySelector('[data-welcome-next]');
    if (prev) prev.addEventListener('click', function () { scrollByCard(-1); });
    if (next) next.addEventListener('click', function () { scrollByCard(1); });

    var scrollTimer = 0;
    scroller.addEventListener('scroll', function () {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(function () {
        normalizeLoop();
        syncCentered();
      }, 90);
    });

    root._welcomeTimers = timers;
  }

  function boot(scope) {
    var roots = [];
    if (scope && scope.matches && scope.matches('[data-welcome-products]')) roots.push(scope);
    if (scope && scope.querySelectorAll) {
      roots = roots.concat(Array.prototype.slice.call(scope.querySelectorAll('[data-welcome-products]')));
    }
    if (!scope) roots = Array.prototype.slice.call(document.querySelectorAll('[data-welcome-products]'));
    roots.forEach(init);
  }

  boot(document);

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('[data-welcome-products]');
    if (!root) return;
    if (root._welcomeTimer) window.clearInterval(root._welcomeTimer);
    if (root._welcomeNext) window.clearTimeout(root._welcomeNext);
    (root._welcomeTimers || []).forEach(function (timer) { window.clearTimeout(timer); });
  });
})();
